// src/hooks/useAutoScale.js
import { useEffect } from "react";

/**
 * Auto-scale the #autoscale-wrapper only when:
 *   • viewport width ≥ minWidth
 *   • AND orientation is portrait
 */
export default function useAutoScale(minWidth = 1024, baseWidth = 1024) {
  useEffect(() => {
    const wrapper = document.getElementById("autoscale-wrapper");
    if (!wrapper) return;

    function updateScale() {
      const isDesktopWide = window.innerWidth >= minWidth;
      const isPortrait   = window.matchMedia("(orientation: portrait)").matches;

      if (isDesktopWide && isPortrait) {
        const scale = window.innerWidth / baseWidth;
        wrapper.style.transformOrigin = "top left";
        wrapper.style.transform = `scale(${scale})`;
      } else {
        wrapper.style.transform = "";
      }
    }

    updateScale();
    window.addEventListener("resize", updateScale);
    return () => window.removeEventListener("resize", updateScale);
  }, [minWidth, baseWidth]);
}
